module.exports = __webpack_public_path__ + "img/empty.ded3c825.png";